import React from 'react';

// Legal footer shown at the bottom of every client-facing page.
// Content here is the FCA / ICO disclosure block that Fair (Reclaims 4 U
// Ltd) is required to surface. Sourced from AppConfig.legal_disclosure_html
// when present (so legal updates don't need a redeploy); otherwise we fall
// back to the canonical block from the May-2026 brand refresh.
const DEFAULT_DISCLOSURE = `You can claim for free, without using a CMC, first to your finance provider or to the FOS/FSCS. Fair is a trading style of Reclaims 4 U Ltd. Reclaims 4 U Ltd is authorised and regulated by the Financial Conduct Authority with reference number FRN 830181. Reclaims 4 U Ltd is a Claims Management Company (CMC). Registered in England and Wales, Company number 6651869. Registered with the Information Commissioner's Office: registration number Z1480043. Registered Address: Unit 1.02b, Boatshed, Office Village, 12 Exchange Quay, Salford, M5 3EQ. VAT Number: 989 401772.`;

export default function LegalFooter({ disclosure, copyrightOwner = 'Fair' }) {
  const year = new Date().getFullYear();
  return (
    <footer className="legal-footer" role="contentinfo">
      <p>{disclosure || DEFAULT_DISCLOSURE}</p>
      <div className="copyright">Copyright © {year} {copyrightOwner}. All rights reserved.</div>
    </footer>
  );
}
